<template>
  <transition name="fade">
    <div class="grm-menu-component" v-if="open">
      <div class="grm-menu-outside" @click="onClickOutside"></div>
      <div class="grm-menu-wrapper">
        <ul class="grm-menu">
          <li v-for="(item, i) in menuList" :key="i" class="grm-menu-item" :class="[item.type]">
            <div v-if="item.type === 'divider'" class="model-list-divider"></div>
            <button v-else
                    class="grm-menu-button"
                    :class="[
                        textAlign,
                        { toggle: !!item.toggleStatus },
                        { toggleOn: item.toggleStatus && item.toggleStatus() === true },
                        { toggleOff: item.toggleStatus && item.toggleStatus() === false },
                        { disabled: item.disabled },
                    ]"
                    :style="itemStyle(item)"
                    @click="onClickItem($event, item)"
            >{{ item.title }}</button>
          </li>
        </ul>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'GrmMenu',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      required: true
    },
    textAlign: {
      type: String,
    }
  },
  computed: {
    menuList () {
      return this.list.filter(item => item.show === undefined || item.show)
    },
    itemStyle() {
      return item => {
        const style = {}
        if (item.icon) {
          let iconFileName = item.icon
          if (!iconFileName.includes('.png')) {
            iconFileName = iconFileName.concat('.svg')
          }
          style.background = `url(${require('@/assets/images/'+iconFileName)}) no-repeat center left 10px / 14px auto`
          style.paddingLeft = '32px'
          style.color = item.icon === 'trash_red' ? '#fa3250' : '#333'
        }
        if (item.selected !== undefined) {
          style.padding = '0 32px'
          if (item.selected()) {
            style.background = `url(${require('@/assets/images/check_blue.svg')}) no-repeat center left 14px / 10px auto`
          }
        }
        return style
      }
    }
  },
  methods: {
    onClickOutside() {
      this.onClose()
    },
    onClickItem(e, item) {
      item.click(e, item)
      this.onClose()
    },
    onClose() {
      this.$emit('update:open', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.grm-menu-component {
  min-width: max-content;
  z-index: 999999;
}
.grm-menu-outside {
  position: fixed;
  inset: 0;
}
.grm-menu-wrapper {
  min-width: max-content;
  width: 100%;
  padding: 6px 0;
  border-radius: 6px;
  background-color: #fff;
  box-shadow: 4px 10px 30px rgb(0 0 0 / 40%);
  position: relative;
  overflow-y: hidden;
}
.grm-menu {
  display: flex;
  flex-direction: column;
}
.grm-menu-item {
  height: 34px;
  &.divider {
    height: auto;
  }
}
.model-list-divider {
  width: 100%;
  height: 1px;
  margin: 6px 0;
  background-color: #ddd;
}
.grm-menu-button {
  width: 100%;
  height: 100%;
  padding: 0 14px;
  font-size: 12px;
  color: #222;
  transition: 0.1s ease-out;
  &.left {
    text-align: left;
  }
  &.toggle {
    display: flex;
    justify-content: space-between;
    align-items: center;
    &::after {
      font-size: 12px;
      font-weight: 700;
      display: block;
      pointer-events: none;
    }
    &.toggleOn {
      &::after {
        content: 'ON';
        color: $mainColor;
      }
    }
    &.toggleOff {
      &::after {
        content: 'OFF';
        color: #bbb;
      }
    }
  }
  &.disabled {
    color: #bbb;
    cursor: not-allowed;
  }
  &:hover {
    background-color: #f1f1f1 !important;
  }
}
</style>